import React from 'react'
import Ball from './Ball'
const Balls = ({ addStake }) => {

  function addBall(ball){
    addStake(ball)
    console.log(ball)
  }

  return (
    <div className='bg-white rounded-lg grid grid-cols-5 gap-10 p-4 '>
      {Array.from({ length: 10 }, (_, i) => (
        <Ball i={i} addBall={addBall}/>
        ))}
      </div>
  )
}

export default Balls